import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import {
  ACCOUNT_TYPES,
  APPLICATION_TYPE_STRING,
  CorporateAccountType,
  REGISTRATION_FLOW_TYPES,
} from '../util/constants';
import { corporateAccountMenu } from '../constants/menus/corporateAccountMenu';
import { individualAccountMenu } from '../constants/menus/individualAccountMenu';
import { retirementPersonalAccountMenu } from '../constants/menus/retirementPersonalAccountMenu';
import { jointAccountMenu } from '../constants/menus/jointAccountMenu';
import { utmaAccountMenu } from '../constants/menus/utmaAccountMenu';
import { applicationTypeStringHelper } from '../util/helpers/applicationTypeStringHelper';
import {
  retrieveFromSessionStorage,
  storeInSessionStorage,
} from '../util/helpers/sessionStorageHelper';
import {
  APPLICATION_TYPE,
  ACCOUNT_TYPE,
  REGISTRATION_FLOW_TYPE,
} from '../constants/sessionStorage';
import { trustAccountMenu } from '../constants/menus/trustAccountMenu';
import { selectApplication } from '../store/selectors/applicationSelectors';
import { metalStreamMenu } from '../constants/menus/metalStreamMenu';
import { PAGES } from '../constants/pages';
import { JWT_TOKEN } from '../constants/localStorage';
import { applicationStepRedirectionHelper } from '../util/helpers/applicationStepHelper';
import LoadingMessage from '../components/LoadingMessage';
import { selectSettings } from '../store/selectors/settingsSelectors';

const LoginUserLoadingPage = () => {
  const history = useHistory();
  const Application = useSelector(selectApplication);
  const { BrokerCode } = useSelector(selectSettings);

  const redirectTo = (applicationType, accountType) => {
    // For Metal Stream Flow
    if (Application.RegistrationFlowType === 2) {
      return metalStreamMenu[1].path;
    }

    // For Standard Flow
    if (accountType === CorporateAccountType[4]) {
      return trustAccountMenu[1].path;
    }

    switch (applicationType) {
      case APPLICATION_TYPE_STRING[1]:
        return individualAccountMenu[1].path;

      case APPLICATION_TYPE_STRING[2]:
        return corporateAccountMenu[1].path;

      case APPLICATION_TYPE_STRING[3]:
        return retirementPersonalAccountMenu[1].path;

      case APPLICATION_TYPE_STRING[4]:
        return jointAccountMenu[1].path;

      case APPLICATION_TYPE_STRING[5]:
        return utmaAccountMenu[1].path;

      default:
        break;
    }
  };

  useEffect(() => {
    const JwtToken = retrieveFromSessionStorage(JWT_TOKEN);

    if (!JwtToken) {
      if (
        retrieveFromSessionStorage(REGISTRATION_FLOW_TYPE) ===
        REGISTRATION_FLOW_TYPES.AIP
      ) {
        history.replace(PAGES.AIP);
      } else {
        history.replace(PAGES.BASE);
      }
    }

    if (isEmpty(Application)) {
      return;
    }

    const { ApplicationType } = Application;

    if (applicationStepRedirectionHelper(Application)) {
      return;
    }

    if (ApplicationType) {
      const applicationTypeString = applicationTypeStringHelper(
        ApplicationType,
      );

      if (applicationTypeString) {
        storeInSessionStorage(APPLICATION_TYPE, applicationTypeString);

        const accountData = Application[applicationTypeString];

        if (accountData && applicationTypeString && accountData?.AccountType) {
          const accountTypeString =
            ACCOUNT_TYPES[applicationTypeString][accountData?.AccountType];

          if (accountTypeString) {
            storeInSessionStorage(ACCOUNT_TYPE, accountTypeString);

            // If Application Step is defined, redirect to it
            // If not redirect to the matching menu item defined by applicationType and AccountType
            history.push(redirectTo(applicationTypeString, accountTypeString));
            return;
          }
        }

        // If Application Step is defined, redirect to it
        // If not redirect to the matching menu item defined by applicationType
        history.push(redirectTo(applicationTypeString));
        return;
      }
    }

    history.push(PAGES.CHOOSE_APPLICATION.MAIN);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Application]);

  return <LoadingMessage BrokerCode={BrokerCode} />;
};

export default LoginUserLoadingPage;
